export const getJWTToken = () => {
    return localStorage.getItem('jwt') || null;
}

export const getUserRole = () => {
    return localStorage.getItem('userRole') || null;
};

export const setUserRole = (role) => {
    localStorage.setItem('userRole', role);
};

export const clearUserRole = () => {
    localStorage.removeItem('userRole');
};

export const clearAuthentication = () => {
    localStorage.removeItem('jwt');
    localStorage.removeItem('userRole');
};

export const decodeJWT = (token) => {
    try {
        const payload = token.split('.')[1];
        return JSON.parse(atob(payload));
    } catch (e) {
        console.error('Failed to decode JWT:', e);
        return null;
    }
};
